import { useState, useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import styles from "./Layout.module.css";
import SideBar from "./Sidebar";
import { IoMenuOutline } from "react-icons/io5";
import UserProfileIcon from "./userProfileIcon";
import { APP_NAME } from "../../utils/appConstant";
export interface UserDetailsProps {
  userName: string;
  userEmail: string;
  loginType: string;
}
export interface UserDetailsObjectProps {
  userDetails: UserDetailsProps;
}
const Layout = () => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const layOutTitle =
    location.pathname.includes("/workbench") || location.pathname == "/"
      ? "Workbench"
      : location.pathname.includes("/privacy")
      ? "Privacy and Data Protection Policy"
      : location.pathname.includes("/interactions")
      ? "Interactions"
      : location.pathname.includes("/interaction")
      ? "Interaction"
      : location.pathname.includes("/change-password")
      ? ""
      : location.pathname.includes("/terms&privacy-policy")
      ? "Terms Of Use and Privacy Policy"
      : "";

  const [userDetails, setUserDetails] = useState({
    userName: "",
    userEmail: "",
    loginType: ""
  });

  useEffect(() => {
    // Retrieve mentee_data from localStorage
    const menteeData = localStorage.getItem("mentee_data");

    // Check if menteeData exists and is valid JSON
    if (menteeData) {
      try {
        const parsedData = JSON.parse(menteeData); // Parse JSON string
        setUserDetails({
          userName: parsedData.name || "", // Extract name
          userEmail: parsedData.email || "", // Extract email
          loginType: parsedData.login_type || ""
        });
      } catch (error) {
        console.error("Error parsing mentee_data from localStorage:", error);
        // Handle invalid JSON (optional: reset or clear mentee_data)
      }
    }
  }, []);

  return (
    <div className={`${styles.layout} w-full`}>
      <header className={`${styles.header} h-16 top-0 z-50 w-full shadow-lg`} role={"banner"}>
        <div className={`${styles.headerContainer} h-16 flex items-center justify-between `}>
          {/* menu button for mobile */}
          <div className="flex">
            <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="sm:hidden text-white">
              {/* {isSidebarOpen ? <RxCross2 className="w-7 h-7" /> : <IoMenuOutline className="w-7 h-7" />} */}
              <IoMenuOutline className="w-7 h-7" />
            </button>

            <Link to="/" className={styles.headerTitleContainer}>
              <h3 className={styles.headerTitle}>{APP_NAME}</h3>
            </Link>
          </div>
          <h3 className="font-bold heading_text_color truncate min-w-24">{layOutTitle}</h3>

          <div className="flex items-center gap-4">
            <div className={`${styles.headerRightText} flex items-center gap-4`}>
              <div className="min-w-16">
                <a href="https://www.pm-powerconsulting.com/" target="_blank">
                  <img src="/PM_POWER_LOGO_WHITE-2019.png" className="justify-self-end h-10" alt="PM Power Logo" />
                </a>
              </div>

              <div className="hidden sm:block min-w-10">
                <UserProfileIcon userDetails={userDetails}></UserProfileIcon>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className={`flex relative`}>
        {/* desktop sidebar */}
        <div className={`hidden sm:block transition-all duration-300 ease-in-out `}>
          <SideBar userDetails={userDetails} />
        </div>

        {/* mobile sidebar */}
        {isSidebarOpen && (
          <div
            className={`sm:hidden  inset-y-0 left-0 bg-background z-30 shadow-lg transform transition-transform duration-300 ease-in-out ${
              isSidebarOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          >
            <SideBar userDetails={userDetails}></SideBar>
          </div>
        )}

        <main className={`flex-1 pb-0 pl-4 pr-4 overflow-y-auto `}>
          <Outlet context={isSidebarOpen} />
        </main>
      </div>
    </div>
  );
};

export default Layout;
